import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.related-slider', {
    modules: [Navigation, Autoplay],
    loop: true,
    speed: 1000,
    spaceBetween: 32,
    slidesPerView: 1,
    breakpoints: {
        550: {
            slidesPerView: 1.2,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    },
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.rel-swiper-next-btn',
        prevEl: '.rel-swiper-prev-btn',
    },
});


document.querySelectorAll('.wc-tabs li a').forEach((tab) => {
    tab.addEventListener('click', () => {
        setTimeout(() => {
            const target = document.querySelector('.WoocommerceTabs');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    });
});